<div class="delete-sample-dialog-container">
    <div class="delete-sample-dialog-header-container">
        <div>  <p class="delete-sample-dialog-header-text delete-sample-section-headers">{{ 'NEW-SAMPLE-DELETE-DIALOG.DELETE-SAMPLE' | translate }}</p></div>
        <div><p class="delete-sample-dialog-sub-heading">{{ 'NEW-SAMPLE-DELETE-DIALOG.TITLE' | translate }}</p></div>
    </div>

    <div class="delete-sample-btn-dialog-container">

        <button class="cancel-delete-sample-dialog-btn" mat-flat-button type="button" (click)="close()">
            <div class="cancel-delete-sample-btn-content">
                <span><p class="cancel-delete-sample-btn-text">{{ 'NEW-SAMPLE-DELETE-DIALOG.CANCEL' | translate }}</p></span>
            </div>
        </button>

        <button class="delete-sample-btn" mat-flat-button type="button" (click)=deleteSample()>
            <div class="delete-sample-btn-content">
                <span><p class="delete-sample-btn-text">{{ 'NEW-SAMPLE-DELETE-DIALOG.DELETE' | translate }}</p></span>
            </div>
        </button>
    </div>

</div>



